import React from 'react';
import Page from '../components/Page';
import { FormattedMessage } from 'react-intl';

const Direitos = (props) => {
   return(
      <Page bg="/assets/img/direitos-bg.jpg">
         <h1><FormattedMessage id="direitos.h1"/></h1>
         <h3><FormattedMessage id="direitos.h3"/></h3>
         <p><FormattedMessage id="direitos.p1" values={{
            a: msg => (
               <a className="link" target="_blank" rel="noopener noreferrer" href="https://www.ilo.org/global/topics/coronavirus/lang--en/index.htm">{msg}</a>
            )
         }}/></p>
         <strong><FormattedMessage id="direitos.strong"/></strong>
         <h2><FormattedMessage id="direitos.h2"/></h2>
         <p><FormattedMessage id="direitos.p2"/></p>
         <ol>
            <li><FormattedMessage id="direitos.ol1.li1"/></li>
            <li><FormattedMessage id="direitos.ol1.li2"/></li>
            <li><FormattedMessage id="direitos.ol1.li3"/></li>
            <li><FormattedMessage id="direitos.ol1.li4"/></li>
            <li><FormattedMessage id="direitos.ol1.li5"/></li>
         </ol>
         <p><FormattedMessage id="direitos.p3"/></p>
         <ol className="numbered-list">
            <li><FormattedMessage id="direitos.ol2.li1"/></li>
            <li><FormattedMessage id="direitos.ol2.li2"/></li>
            <li><FormattedMessage id="direitos.ol2.li3"/></li>
            <li><FormattedMessage id="direitos.ol2.li4"/></li>
         </ol>
      </Page>
   )
}

export default Direitos;